import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Html5QrcodeScanner } from "html5-qrcode";
import "bootstrap/dist/css/bootstrap.min.css";
import "./scanner.css"; // Import at the top of the file


const ScannerForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [qrData, setQrData] = useState("Tiger");
  const userData = location.state || JSON.parse(localStorage.getItem("scannerData")) || {};

// Destructure the data
const { name, age, gender, birthDate, autismProfile, preferences } = userData;

// Debug
console.log("Location State:", location.state);
console.log("LocalStorage Data:", localStorage.getItem("scannerData"));
  const [showModal, setShowModal] = useState(false);
  const [text, setText] = useState(`My name is ${name} and I am ${gender} born in ${birthDate}. I have ${autismProfile} and learning preferences is ${preferences}. Imagine you are a teacher and teach me about ${qrData} in above way less than 100 words`);

  useEffect(() => {
    const scanner = new Html5QrcodeScanner("qr-reader", { fps: 10, qrbox: 250 });

    scanner.render(
      (decodedText) => {
        setQrData(decodedText);
        
      },
      (error) => console.log(error)
    );

    return () => scanner.clear();
  }, []);

  useEffect(() => {
    setText(`My name is ${name} and I am ${gender} born in ${birthDate}. I have ${autismProfile} and learning preferences is ${preferences}. Imagine you are a teacher and teach me about ${qrData} in above way less than 100 words`);
  }, [name, age, birthDate, gender, qrData]);  

  const handleSubmit = () => {
    if (!name || !age || !birthDate) {
      alert("Please fill all fields!");
      return;
    }

    navigate("/result", { state: { name, age, birthDate, qrData, text } });
  };

  return (
    <>
    <div className="container flex flex-column justify-center items-center bg-[#080326] text-white text-opacity-80 text-[16px] leading-[1.5] font-[Mulish] min-h-screen min-w-full">

        <div className="py-[10px]">
			<div className="max-w-[520px] mx-auto px-[15px]">
				<div className="relative">
					<img className="absolute top-0 left-0 w-full h-full object-cover object-center rounded-[15px]" src="https://raw.githubusercontent.com/uiaextend/jenfhess/main/40_Home_1_Default_Light/cta/Background.png" alt=""/>
					<div className="relative pb-[100px]">
						<div className="flex justify-center gap-[30px]">
							<div className="hidden md:flex flex-col items-center">
								<div className="pt-[150px] w-[10px] border-r-[1px] border-l-[1px] border-[#3F5EFB] border-opacity-50"></div>
								<div className="">
									<div className="h-[10px] w-[0px] bg-gradient-to-tr from-[#FC466B] to-[#3F5EFB] rounded-full"></div>
									<div className="py-[10px]"></div>
									<div className="h-[10px] w-[50px] bg-gradient-to-tr from-[#FC466B] to-[#3F5EFB] rounded-full"></div>
								</div>
							</div>
							<div className="">
								<div className="pt-[140px]"></div>
								<div className="flex justify-center items-center">
                                <div id="qr-reader" className="text-center"></div>
                                </div>
								<div className="pt-[20px]"></div>
                                <div className="flex justify-center gap-[10px]">
                                <div className="text-[30px] md:text-[25px] leading-[1] font-bold  text-[#3F5EFB]">Scanned QR: {qrData || "No QR scanned"}</div>
								</div>
								
							</div>
                            
							<div className="hidden md:flex flex-col items-center">
								<div className="pt-[150px] w-[10px] border-r-[1px] border-l-[1px] border-[#3F5EFB] border-opacity-50"></div>
								<div className="">
									<div className="h-[10px] w-[50px] bg-gradient-to-tr from-[#FC466B] to-[#3F5EFB] rounded-full"></div>
									<div className="py-[10px]"></div>
									<div className="h-[10px] w-[50px] bg-gradient-to-tr from-[#FC466B] to-[#3F5EFB] rounded-full"></div>
								
                                </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

        <div className="d-flex w-80 gap-2 mb-4">
        <button className="btn btn-primary flex-grow-1 mt-3" onClick={handleSubmit}>Submit</button>
        <button className="btn btn-secondary flex-grow-0 mt-3" onClick={() => setShowModal(true)}>Prompt</button>
      </div>
      {/* Modal */}
 {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Prompt</h5>
                
              </div>
              <div className="modal-body">
              <textarea
                  className="form-control"
                  rows="6"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Backdrop Overlay */}
      {showModal && <div className="modal-backdrop fade show"></div>}
    </div>
    
      

     

    
      
      </>
  );
};

export default ScannerForm;
